module.exports = __webpack_public_path__ + "static/media/Logotipo_ExameSaintPaul_Preto-scaled.6758fbf7.png";